export function measurePerformance(componentName: string, startTime: number) {
  const endTime = performance.now();
  const duration = endTime - startTime;
  
  // Log performance data
  console.debug(`[Performance] ${componentName} rendered in ${duration.toFixed(2)}ms`);
  
  // Send to analytics if duration is above threshold
  if (duration > 1000) {
    console.warn(`[Performance] Slow render detected in ${componentName}: ${duration.toFixed(2)}ms`);
  }
}

export function trackResourceTiming() {
  if (window.performance && window.performance.getEntriesByType) {
    const resources = window.performance.getEntriesByType('resource');
    const slowResources = resources.filter(
      (resource) => resource.duration > 1000
    );
    
    if (slowResources.length > 0) {
      console.warn('[Performance] Slow resources detected:', 
        slowResources.map(r => ({
          name: r.name,
          duration: r.duration.toFixed(2)
        }))
      );
    }
  }
}